import { Typography } from 'antd';
import { ContainerOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    isUnarchiving?: boolean;
    onClose: () => void;
    onUnarchive: () => void;
};

const UnarchiveCustomer = ({ open, isUnarchiving, onUnarchive, onClose }: Props) => {
    return (
        <ConfirmationModal
            width={420}
            open={open}
            icon={<ContainerOutlined />}
            title="Unarchive Customer?"
            confirmButtonText="Unarchive"
            confirmationButtonLoading={isUnarchiving}
            onCancel={onClose}
            onConfirm={onUnarchive}
            content={<Typography.Text>The customer will be removed from the archive.</Typography.Text>}
        />
    );
};

export default UnarchiveCustomer;
